export default __webpack_public_path__ + "static/media/makan_erp_logo_xl.b902f7de.png";